document.addEventListener('DOMContentLoaded', function() {

  const customSelects = document.querySelectorAll('.custom-select');
  const filterAndSort = document.querySelector("#tab-refine");
  
  function setupMobileTabletFunctionality() {
    if (screen.width < 769) {
      console.log(screen.width);
      if (filterAndSort) {
        filterAndSort.removeEventListener('click', handleFilterAndSortClick);
        filterAndSort.addEventListener('click', handleFilterAndSortClick);
      }
    } else{
      if (filterAndSort) {
        const items = document.querySelector('.select-items');


        filterAndSort.removeEventListener('click', handleFilterAndSortClick);
      }
    }
   
  }
  
  function handleFilterAndSortClick(e) {
    e.preventDefault();
    const sidebar=document.querySelector(".sidebar")

    const items = document.querySelector('.select-items');
    console.log(sidebar.classList.contains("active"));
    if(sidebar){
      if(sidebar.classList.contains("active")){
        sidebar.classList.remove("active")
      }else{
        sidebar.classList.add("active")

      }
    }
    if (items) {
      
      if (items.style.display === "none" || items.style.display === "") {
        items.style.display = "flex";
      } else {
        items.style.display = "none";
      }
    }
   
  }
  
  setupMobileTabletFunctionality();
  
  window.addEventListener('resize', setupMobileTabletFunctionality);
 

  
  customSelects.forEach(function(select) {
    const selected = select.querySelector('.select-selected');
    const items = select.querySelector('.select-items');
    const options = select.querySelectorAll('.sortby-option');
    const hiddenInput = select.querySelector('input[type="hidden"]');
    
    selected.removeEventListener('click', handleSelectedClick);
    selected.addEventListener('click', handleSelectedClick);


        items.style.display = "absolute";



    
    function handleSelectedClick(e) {
      e.stopPropagation();
      closeAllSelect(this);
      console.log("22");
      console.log(items.classList.contains("select-hide"));

      if (items.classList.contains("select-hide")) {
        items.classList.remove("select-hide");
        items.style.display = "block";
      } else {
        items.classList.add("select-hide");
        items.style.display = "none";
      }

      this.classList.toggle('select-arrow-active');
    }
    
    options.forEach(function(option) {
      option.removeEventListener('click', handleOptionClick);
      option.addEventListener('click', handleOptionClick);
      
      function handleOptionClick(e) {
        e.stopPropagation();
        console.log(option);
        const sidebar=document.querySelector(".sidebar")

        select.style.width = "100%";

        selected.textContent = `SortBy:  ${this.textContent}`;
        
        hiddenInput.value = this.dataset.value;
        
        options.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');
        
        items.classList.add('select-hide');
        selected.classList.remove('select-arrow-active');
        
        const event = new Event('change', { bubbles: true });
        hiddenInput.dispatchEvent(event);
        sidebar.classList.remove("active")
        items.style.display = "none";


        setTimeout(() => {
          if (typeof window.initializeProductSwiper === 'function') {
            console.log("Initializing Swiper...");
            window.initializeProductSwiper();
          } else {
            console.warn("initializeProductSwiper function not found");
          }
        }, 100);
      }
    });
  });
  
  document.addEventListener('click', closeAllSelect);
  
  function closeAllSelect(elmnt) {
    const items = document.querySelectorAll('.select-items');
    const selected = document.querySelectorAll('.select-selected');
    
    items.forEach(function(item) {
      if (elmnt !== item && elmnt !== item.previousElementSibling) {
        item.classList.add('select-hide');
      }
    });
    
    selected.forEach(function(sel) {
      if (elmnt !== sel) {
        sel.classList.remove('select-arrow-active');
      }
    });
  }
}); 